import { defineComponent as _defineComponent } from 'vue'
import { PropType, nextTick } from 'vue'
import { ButtonGift, AppButton } from '@shared/ui'
import { useCustomLogicModel } from '@shared/model'
import { useOrderModel } from '@entities/order'
import { computed } from '@nuxtjs/composition-api'
import { amplitudeLogEvent, amplitudeEvents } from '@shared/lib'
import { useRestaurantModel } from '@entities/restaurant'
import { discountGetData } from '@entities/discount'
import { useThemeModel } from '@entities/theme'
import { usePaymentModals } from '@entities/paymentModals/usePaymentModals'
import PaymentModals from '@/components/Payment/PaymentModals.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PayedVariants',
  props: {
  paymentMethod: {
    type: String as PropType<string>,
    required: true,
    default: 'sbp'
  },
  disabled: {
    type: Boolean as PropType<boolean>,
    required: true,
    default: false
  },
  totalSum: {
    type: String as PropType<string>,
    required: false,
    default: '0'
  },
  tips: {
    type: String as PropType<string>,
    required: false,
    default: '0'
  },
  currencyIcon: {
    type: String as PropType<string>,
    required: false,
    default: ''
  }
},
  emits: [
  'togglePaymentMethodModal',
  'callYandexMetricGoal',
  'togglePreloader',
  'onPaymentWithoutDiscount',
  'pay'
],
  setup(__props, { emit }) {

const props = __props

const customLogicModel = useCustomLogicModel()
const orderModel = useOrderModel()
const restaurantModel = useRestaurantModel()
const themeModel = useThemeModel()
const {
  modalState,
  openConfirmModal,
  handleCheckPrinted,
  proceedToPayment,
  handlePaymentCancel,
  handleCheckPrintClose,
  printCheck
} = usePaymentModals()





const sumTotalSum = computed(() => (parseFloat(props.totalSum) + parseFloat(props.tips)).toFixed(2))

// Скролл к якорю политики конфиденциальности
const scrollToPrivacyPolicy = () => {
  const element = document.getElementById('privacy-policy-anchor')
  if (element) {
    element.classList.add('highlight-scroll')
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    })

    setTimeout(() => {
      element.classList.remove('highlight-scroll')
    }, 2000)
  }
}

// Функция обработки оплаты
const handlePayment = async () => {
  const privacyCheckbox = document.querySelector('input[name="policy"]') as HTMLInputElement
  const isPolicyAccepted = privacyCheckbox ? privacyCheckbox.checked : false

  if (!isPolicyAccepted) {
    await nextTick()
    scrollToPrivacyPolicy()
    return
  }

  if (props.disabled) {
    return
  }

  // Если требуется подтверждение - показываем модалку
  if (restaurantModel.isPreliminaryCheckOfIntent && props.paymentMethod === 'card' && !orderModel.orderData.orders[0].preliminaryCheckOfIntent) {
    openConfirmModal()
  } else {
    // Иначе сразу продолжаем оплату
    await checkingDiscount()
  }
}

const proceedWithPayment = () => {
  if (!orderModel.orderData) { return }

  proceedToPayment(() =>
    printCheck({
      orderData: orderModel.orderData,
      totalAmount: parseFloat(sumTotalSum.value),
      restaurantCode: restaurantModel.code
    })
  )
}

const handleModalCheckPrintClose = () => {
  handleCheckPrintClose(() => {
    checkingDiscount()
  })
}

const handleCheckPrintedWithPayment = () => {
  handleCheckPrinted()
  checkingDiscount()
}

const pay = () => {
  amplitudeLogEvent(amplitudeEvents.PAYMENT)
  emit('pay')
}

const togglePaymentMethodModal = () => {
  emit('togglePaymentMethodModal')
}

const checkingDiscount = async () => {
  emit('callYandexMetricGoal', 'pay')
  emit('togglePreloader')
  if (orderModel.orderData && orderModel.orderData.discount === 0 && orderModel.orderData.loyalty_system === 'NOVIKOV') {
    const res = await discountGetData({ sessions_id: parseInt(orderModel.orderData?.session) })
    if (res.data.result.code === 101 || res.data.result.code === 102 || res.data.result.code === 104) {
      emit('onPaymentWithoutDiscount')
    } else {
      pay()
    }
  } else {
    pay()
  }
}

// const isNovikov = ref(false)
// let observer = null

const cardImage = computed(() =>
  themeModel.theme.toLowerCase() === 'novikov' ? require('@shared/assets/card-icon-red.svg') : require('@shared/assets/card-icon.svg')
)

// onMounted(() => {
//   if (typeof document !== 'undefined') {
//     isNovikov.value = document.body.classList.contains('novikov')
//
//     // Следим за изменением классов body
//     observer = new MutationObserver(() => {
//       isNovikov.value = document.body.classList.contains('novikov')
//     })
//
//     observer.observe(document.body, {
//       attributes: true,
//       attributeFilter: ['class']
//     })
//   }
// })
//
// onUnmounted(() => {
//   if (observer) {
//     observer.disconnect() // Останавливаем наблюдение
//   }
// })

return { __sfc: true,customLogicModel, orderModel, restaurantModel, themeModel, modalState, openConfirmModal, handleCheckPrinted, proceedToPayment, handlePaymentCancel, handleCheckPrintClose, printCheck, props, emit, sumTotalSum, scrollToPrivacyPolicy, handlePayment, proceedWithPayment, handleModalCheckPrintClose, handleCheckPrintedWithPayment, pay, togglePaymentMethodModal, checkingDiscount, cardImage, ButtonGift, AppButton, PaymentModals }
}

})